import { render } from "./dashboardLead.vue?vue&type=template&id=281f8f96&ts=true"
import script from "./dashboardLead.vue?vue&type=script&lang=ts"
export * from "./dashboardLead.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__